// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"b947d72d","540":"b947d72d","688":"5b38d61c","778":"5b38d61c"}[chunkId] + ".chunk.css";
};